import styled, { css } from 'styled-components';

export const Toolbar = styled.div(
  ({ theme: { palette } }) => css`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 16px;
    background-color: ${palette.common.white};
    border: 1px solid ${palette.chart.grid};
    border-radius: 8px;
  `,
);

export const ToolbarLabel = styled.span(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: ${palette.info.main};
  `,
);

export const Spacer = styled.div`
  flex-grow: 1;
`;

export const GrafanaLink = styled.a(
  ({ theme: { palette } }) => css`
    font-size: 13px;
    font-weight: 500;
    color: ${palette.primary.main};
    text-decoration: none;
  `,
);

export const ProcessGrid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr repeat(5, minmax(0, 1fr));
  gap: 16px;
  align-items: center;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ProcessIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MetricLabel = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: ${palette.info.main};
  `,
);

export const MetricValue = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 22px;
    font-weight: 700;
    color: ${palette.text.secondary};

    small {
      font-size: 13px;
      font-weight: 500;
      color: ${palette.info.main};
    }
  `,
);

export const MetricDetail = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    color: ${palette.text.primary};
  `,
);

export const PodName = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 15px;
    font-weight: 600;
    color: ${palette.text.secondary};
  `,
);

export const Mono = styled.div`
  font-family: 'JetBrains Mono', ui-monospace, Menlo, monospace;
  font-size: 12px;
`;

export const MutedMono = styled(Mono)(
  ({ theme: { palette } }) => css`
    color: ${palette.info.main};
  `,
);

export const Track = styled.div(
  ({ theme: { palette } }) => css`
    height: 6px;
    border-radius: 3px;
    background-color: ${palette.grey[200]};
    overflow: hidden;
  `,
);

export const TrackFill = styled.div<{ $ratio: number; $tone: 'ok' | 'primary' }>(
  ({ theme: { palette }, $ratio, $tone }) => css`
    width: ${Math.round($ratio * 100)}%;
    height: 6px;
    border-radius: 3px;
    background-color: ${$tone === 'ok' ? palette.chart.ok : palette.primary.main};
  `,
);

export const UnknownCard = styled.div(
  ({ theme: { palette } }) => css`
    border: 1px solid ${palette.chart.warn};
    background-color: #fff4e0;
    border-radius: 8px;
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  `,
);

export const UnknownTitle = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 16px;
    font-weight: 700;
    color: ${palette.chart.warn};
  `,
);

export const StaleBanner = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    color: ${palette.chart.warn};
    margin-bottom: 8px;
  `,
);

export const ConnectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const ConnectionIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ConnectionName = styled.div(
  ({ theme: { palette } }) => css`
    font-size: 16px;
    font-weight: 600;
    color: ${palette.text.secondary};
  `,
);

export const ChipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const PanelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const CardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const TimelineWrapper = styled.div`
  width: 100%;
`;
